import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import Editor from '../../Editor';
import cn from 'classnames';
import { extConfig } from './config';
import GroupAboutBubbleMenu from '../../../menus/GroupAboutBubbleMenu';
import viewerStyles from '../../../Viewer/presets/AdminNote/AdminNote.scss';
import s from './AdminNote.scss';
const AdminNoteEditor = (_param)=>{
    var { validationResult = 'success' } = _param, props = _object_without_properties(_param, [
        "validationResult"
    ]);
    return /*#__PURE__*/ React.createElement(Editor, _object_spread_props(_object_spread({}, props), {
        withinModal: true,
        presetId: "adminnote",
        className: cn(s['root'], viewerStyles['root'], validationResult == 'error' && s['error']),
        extensionConfig: extConfig
    }), (editor, scrollContainer)=>/*#__PURE__*/ React.createElement(GroupAboutBubbleMenu, {
            scrollContainerRef: scrollContainer
        }));
};
AdminNoteEditor.displayName = 'AdminNoteEditor';
export default AdminNoteEditor;

//# sourceMappingURL=AdminNote.js.map